import { render, staticRenderFns } from "./PersonColumn.vue?vue&type=template&id=0354f699&scoped=true&"
import script from "./PersonColumn.vue?vue&type=script&lang=js&"
export * from "./PersonColumn.vue?vue&type=script&lang=js&"
import style0 from "./PersonColumn.vue?vue&type=style&index=0&id=0354f699&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0354f699",
  null
  
)

export default component.exports